var cibSlickpic = ["32 32", "<path d='M28.645 24.412l-20.572-5.631 3.359-12.271 20.568 5.629zM10.76 17.251l16.349 4.473 2.203-8.047-16.353-4.48-2.199 8.048zM11.369 21.063l-6.52 1.744-2.167-8.057 5.525-1.484 0.667-2.443-8.875 2.38 3.303 12.287 12.239-3.292z'/>"];

export { cibSlickpic };

